/** @jsx jsx */
import { jsx } from '@emotion/react';

import { Grid, PageGridContainer, Typography } from '@coursera/cds-core';

import CollectionsContainer from 'bundles/collections-common/components/CollectionsContainer';
import { toCarouselCollection } from 'bundles/unified-description-page-common/components/recommendations/toCarouselCollection';
import Section from 'bundles/unified-description-page-common/components/shared/Section';
import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';
import type { CollectionEntityFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/CollectionEntityFragment';

import _t from 'i18n!nls/xdp';

import CarouselCollectionType from './CarouselCollectionType';

type Props = {
  recommendationsCollection?: CollectionEntityFragment[] | null;
  anchorId?: string;
};

const ProjectRecommendationsModuleNotConfigurable = ({ recommendationsCollection, anchorId }: Props) => {
  const { subfolderLocaleCode } = usePageInfo();

  if (!recommendationsCollection || recommendationsCollection.length === 0) {
    return null;
  }

  return (
    <Section anchorId={anchorId}>
      <PageGridContainer>
        <Grid item xs={12}>
          <Typography variant="h1semibold" component="h3">
            {_t('You might also like')}
          </Typography>
          <CollectionsContainer
            collections={[
              toCarouselCollection({
                recommendationsCollection,
                collectionId: CarouselCollectionType.RECOMMENDATIONS,
                subfolderLocaleCode,
              }),
            ]}
          />
        </Grid>
      </PageGridContainer>
    </Section>
  );
};

export default ProjectRecommendationsModuleNotConfigurable;
